import React from 'react'

export default function SniffingDog({ size = 120 }) {
  return (
    <div className="flex flex-col items-center justify-center">
      <svg
        width={size}
        height={size}
        viewBox="0 0 200 200"
        className="animate-bounce-slow"
      >
        {/* Dog Body */}
        <ellipse cx="100" cy="140" rx="50" ry="35" fill="#8B4513" />

        {/* Dog Head */}
        <circle cx="100" cy="85" r="40" fill="#8B4513" />

        {/* Snout */}
        <ellipse cx="100" cy="100" rx="25" ry="18" fill="#A0522D" />

        {/* Nose */}
        <circle cx="100" cy="95" r="8" fill="#2D1810" />

        {/* Eyes */}
        <circle cx="85" cy="75" r="8" fill="#2D1810" />
        <circle cx="115" cy="75" r="8" fill="#2D1810" />
        <circle cx="87" cy="73" r="3" fill="white" />
        <circle cx="117" cy="73" r="3" fill="white" />

        {/* Ears */}
        <ellipse cx="65" cy="65" rx="18" ry="28" fill="#8B4513" transform="rotate(-20 65 65)" />
        <ellipse cx="135" cy="65" rx="18" ry="28" fill="#8B4513" transform="rotate(20 135 65)" />

        {/* Front Legs */}
        <rect x="70" y="165" width="15" height="30" rx="5" fill="#8B4513" />
        <rect x="115" y="165" width="15" height="30" rx="5" fill="#8B4513" />

        {/* Back Legs */}
        <rect x="60" y="170" width="15" height="25" rx="5" fill="#8B4513" />
        <rect x="125" y="170" width="15" height="25" rx="5" fill="#8B4513" />

        {/* Tail - Wagging animation */}
        <g className="animate-wag">
          <path
            d="M 150 130 Q 170 110 165 140 Q 160 160 150 150"
            fill="#8B4513"
            stroke="#8B4513"
            strokeWidth="8"
            strokeLinecap="round"
          />
        </g>

        {/* Sniffing animation - nose moving */}
        <g className="animate-sniff">
          {/* Scent lines */}
          <g opacity="0.6">
            <path d="M 80 110 Q 70 105 65 100" stroke="#7CB9E8" strokeWidth="2" fill="none" className="animate-fade-in" />
            <path d="M 85 115 Q 72 110 68 105" stroke="#7CB9E8" strokeWidth="2" fill="none" className="animate-fade-in-delay-1" />
            <path d="M 90 118 Q 75 113 70 108" stroke="#7CB9E8" strokeWidth="2" fill="none" className="animate-fade-in-delay-2" />
          </g>
        </g>
      </svg>

      {/* Search text with animation */}
      <div className="mt-4 text-center">
        <p className="text-lg font-semibold text-gray-700 animate-pulse">
          Sniffing through files...
        </p>
        <p className="text-sm text-gray-500 mt-1">
          Analyzing documents and finding matches
        </p>
      </div>

      <style jsx>{`
        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        @keyframes wag {
          0%, 100% {
            transform: rotate(-10deg);
          }
          50% {
            transform: rotate(10deg);
          }
        }

        @keyframes sniff {
          0%, 100% {
            transform: translateX(0);
          }
          50% {
            transform: translateX(3px);
          }
        }

        @keyframes fade-in {
          0% {
            opacity: 0;
            transform: translateX(0);
          }
          50% {
            opacity: 0.6;
          }
          100% {
            opacity: 0;
            transform: translateX(-20px);
          }
        }

        .animate-bounce-slow {
          animation: bounce-slow 2s ease-in-out infinite;
        }

        .animate-wag {
          animation: wag 0.5s ease-in-out infinite;
          transform-origin: 150px 130px;
        }

        .animate-sniff {
          animation: sniff 1s ease-in-out infinite;
        }

        .animate-fade-in {
          animation: fade-in 1.5s ease-out infinite;
        }

        .animate-fade-in-delay-1 {
          animation: fade-in 1.5s ease-out 0.3s infinite;
        }

        .animate-fade-in-delay-2 {
          animation: fade-in 1.5s ease-out 0.6s infinite;
        }
      `}</style>
    </div>
  )
}
